import React from 'react'
import PropTypes from 'prop-types'
import Help from '../Help/Help.jsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import rootActions from 'actions/rootActions'

class SettingsTitle extends React.PureComponent {
  render() {
    const {
      help = true,
      required = false,
      value,
      extra = null,
      htmlFor,
      className = '',
      showColon = true
    } = this.props
    // should colon be displayed after title
    const doShowColon = showColon ? ':' : null
    let { helpString } = this.props

    if (!helpString) {
      helpString = value
      let i = 0
      // replace all spaces with _. Add a 9 replacement max
      // to the loop just in case something unforeseen happens
      // so we cant loop forever
      while (i < 10 && helpString.indexOf(' ') !== -1) {
        helpString = helpString.replace(' ', '_')
        i++
      }
    }
    const astrisk = required ? (
      <span
        id="required"
        aria-label={`setting ${value} required icon`}
        className="settings-title required"
        data-toggle={'tooltip'}
        data-title="This is a required field."
        data-placement="top"
      >
        *
      </span>
    ) : null
    return (
      <div className="settings-item-title">
        <label htmlFor={htmlFor} className={className}>
          <h4>
            {astrisk}
            {value}
            {doShowColon} {extra}
          </h4>
        </label>
        {help ? (
          <Help
            aria-label={`setting ${value} help icon`}
            id={helpString.toUpperCase()}
          />
        ) : null}
      </div>
    )
  }
}

SettingsTitle.propTypes = {
  // Required title value for the settings option
  value: PropTypes.string.isRequired,
  // Boolean indicating if help button should be displayed. Defaults to true.
  // If help is displayed, this.props.value (or helpString, see below) is used as the key to the
  // data/help.js file
  help: PropTypes.bool,
  // override key to the data/help.js file
  helpString: PropTypes.string,
  // option data that appears after the value and colon.
  extra: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Boolean indicating if the field is required resulting in displaying red
  // asterisk. Default is true.
  required: PropTypes.bool
  // Used to link labels with inputs, should have the same value as the inputs id if an SettingsTitle has a corresponding input, otherwise no need to include this propropTypes.string
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(null, mapDispatchToProps)(SettingsTitle)
